import React from "react";
import TermsOfService from "../components/terms/TermsOfService";

const TermsOfServiceSection = () => {
  return (
    <section>
  <TermsOfService />
    </section>
  );
};

export default TermsOfServiceSection;
